import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import modal from '@/app/components/Common/Modal.vue'
import VueHead from 'vue-head'
import VCalendar from 'v-calendar'
import { Chrome } from 'vue-color'
import { quillEditor } from 'vue-quill-editor'
import VueMeta from 'vue-meta'

/* bootstrap */
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/* googlemaps */
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_ACCESS_TOKEN,
    libraries: 'places,geometry,drawing'
  }
})

Vue.use(VueHead)
Vue.use(VCalendar)
Vue.use(Chrome)
Vue.use(quillEditor)
Vue.use(VueMeta)

/* service worker */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // 登録成功
        // 変更があれば更新する
        registration.onupdatefound = function () {
          registration.update()
        }
      })
      // 登録失敗
      .catch(e => console.log('error', e))
  })
}

/* globalcom */
Vue.component('modal', modal)
Vue.config.productionTip = false
// templateで使用するためのグローバル変数を定義する
let GlobalData = new Vue({
  data: {
    $app_name: process.env.VUE_APP_APPLICATION_NAME,
    $service_name: process.env.VUE_APP_SERVICE_NAME,
    $header_title: process.env.VUE_APP_HEADER_TITLE,
    $element_name1: process.env.VUE_APP_ELEMENT1_NAME,
    $element_name2: process.env.VUE_APP_ELEMENT2_NAME,
    $element_name3: process.env.VUE_APP_ELEMENT3_NAME,
    $element_name4: process.env.VUE_APP_ELEMENT4_NAME,
    $element_unit1: process.env.VUE_APP_ELEMENT1_UNIT,
    $element_unit2: process.env.VUE_APP_ELEMENT2_UNIT,
    $element_unit3: process.env.VUE_APP_ELEMENT3_UNIT,
    $element_unit4: process.env.VUE_APP_ELEMENT4_UNIT,
    $planting_type_name1: process.env.VUE_APP_PLANTING_TYPE_NAME1,
    $planting_type_name2: process.env.VUE_APP_PLANTING_TYPE_NAME2,
    $planting_type_name3: process.env.VUE_APP_PLANTING_TYPE_NAME3,
    $planting_type_key1: Number(process.env.VUE_APP_PLANTING_TYPE_KEY1),
    $planting_type_key2: Number(process.env.VUE_APP_PLANTING_TYPE_KEY2),
    $planting_type_key3: Number(process.env.VUE_APP_PLANTING_TYPE_KEY3)
  }
})
// mixin でグローバル変数をラッピングする
Vue.mixin({
  computed: {
    // 各コンポーネント内の<template>タグ内でグローバル変数を参照するための処置
    $app_name: {
      get: function () { return GlobalData.$data.$app_name },
      set: function (newTitle) { GlobalData.$data.$app_name = newTitle }
    },
    $service_name: {
      get: function () { return GlobalData.$data.$service_name },
      set: function (newTitle) { GlobalData.$data.$service_name = newTitle }
    },
    $header_title: {
      get: function () { return GlobalData.$data.$header_title },
      set: function (newTitle) { GlobalData.$data.$header_title = newTitle }
    },
    $element_name1: {
      get: function () { return GlobalData.$data.$element_name1 },
      set: function (newTitle) { GlobalData.$data.$element_name1 = newTitle }
    },
    $element_name2: {
      get: function () { return GlobalData.$data.$element_name2 },
      set: function (newTitle) { GlobalData.$data.$element_name2 = newTitle }
    },
    $element_name3: {
      get: function () { return GlobalData.$data.$element_name3 },
      set: function (newTitle) { GlobalData.$data.$element_name3 = newTitle }
    },
    $element_name4: {
      get: function () { return GlobalData.$data.$element_name4 },
      set: function (newTitle) { GlobalData.$data.$element_name4 = newTitle }
    },
    $element_unit1: {
      get: function () { return GlobalData.$data.$element_unit1 },
      set: function (newTitle) { GlobalData.$data.$element_unit1 = newTitle }
    },
    $element_unit2: {
      get: function () { return GlobalData.$data.$element_unit2 },
      set: function (newTitle) { GlobalData.$data.$element_unit2 = newTitle }
    },
    $element_unit3: {
      get: function () { return GlobalData.$data.$element_unit3 },
      set: function (newTitle) { GlobalData.$data.$element_unit3 = newTitle }
    },
    $element_unit4: {
      get: function () { return GlobalData.$data.$element_unit4 },
      set: function (newTitle) { GlobalData.$data.$element_unit4 = newTitle }
    },
    $planting_type_name1: {
      get: function () { return GlobalData.$data.$planting_type_name1 },
      set: function (newTitle) { GlobalData.$data.$planting_type_name1 = newTitle }
    },
    $planting_type_name2: {
      get: function () { return GlobalData.$data.$planting_type_name2 },
      set: function (newTitle) { GlobalData.$data.$planting_type_name2 = newTitle }
    },
    $planting_type_name3: {
      get: function () { return GlobalData.$data.$planting_type_name3 },
      set: function (newTitle) { GlobalData.$data.$planting_type_name3 = newTitle }
    },
    $planting_type_key1: {
      get: function () { return GlobalData.$data.$planting_type_key1 },
      set: function (newTitle) { GlobalData.$data.$planting_type_key1 = newTitle }
    },
    $planting_type_key2: {
      get: function () { return GlobalData.$data.$planting_type_key2 },
      set: function (newTitle) { GlobalData.$data.$planting_type_key2 = newTitle }
    },
    $planting_type_key3: {
      get: function () { return GlobalData.$data.$planting_type_key3 },
      set: function (newTitle) { GlobalData.$data.$planting_type_key3 = newTitle }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
